import {combineReducers} from '@reduxjs/toolkit';

import {ccdbCompanySearch} from '/src/modules/company-search/services/reducer';
import {ccdbEventDetails} from '/src/modules/event-details/services/reducer';
import {ccdbHoliday} from '/src/modules/holiday/services/reducer';


export const rootReducer = combineReducers({
    ccdbCompanySearch,
    ccdbEventDetails,
    ccdbHoliday,
});
